import { Accordion, AccordionDetails, AccordionSummary,
    Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid,
    IconButton, Stack, Typography, useTheme} from "@mui/material";
import {DownloadRounded, EditRounded, ExpandMore} from "@mui/icons-material";
import {CellValueChangedEvent, ColDef, IServerSideDatasource, ValueFormatterParams} from "ag-grid-community";
import AgGridCustomTable from "../../../../util/component/AgGridCustomTable";
import Tooltip from "@mui/material/Tooltip";
import { useTranslation } from "react-i18next";
import {useCallback, useMemo, useRef, useState} from "react";
import {AgGridReact} from "ag-grid-react";
import {getDashboardData,saveDashboardFile,updateDashboard} from "../service/contractorSearch.actions";
import {DASHBOARD_CONTRACTOR_EMPTY_LIST, DASHBOARD_SHORT_TERMS_EMPTY_LIST, DASHBOARD_CAR_SHARING_EMPTY_LIST} from "../model/data";
import dayjs from "dayjs";
import {useRecoilState} from "recoil";
import {RFMContractorDataValueState} from "../model/state";
import DashboardHistory from "./DashboardHistory";

const CurrentYearDashboardView = () => {
    const [contractorDataState] = useRecoilState(RFMContractorDataValueState);
    const [reload, setReload] = useState(false);
    const [openHistory, setOpenHistory] = useState(false);
    const handleOpenHistory = () => setOpenHistory(true);
    const handleCloseHistory = () => setOpenHistory(false);

    function currencyFormatter(params: ValueFormatterParams) {
        return params.value;
    }

    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const theme = useTheme();
    const [isSearching, setIsSearching] = useState(false);
    const [isEditable, setIsEditable] = useState(false);
    const [contractorData, setContractorData] = useState(DASHBOARD_CONTRACTOR_EMPTY_LIST);
    const [shortTermsData, setShortTermsData] = useState(DASHBOARD_SHORT_TERMS_EMPTY_LIST);
    const [carSharingData, setCarSharingData] = useState(DASHBOARD_CAR_SHARING_EMPTY_LIST);
    const {t, i18n} = useTranslation(['network'])

    const gridRefContractor = useRef<AgGridReact>(null);
    const gridRefShortTime = useRef<AgGridReact>(null);
    const gridRefCarSharing = useRef<AgGridReact>(null);
    const columnContractorDefs = useMemo<ColDef[]>(() => [
        {headerName: t('contractorMng.managerRFM.royalitiesFeesManagementView.contractor.title'),
            children: [
                {field: 'description', headerName: t('contractorMng.managerRFM.royalitiesFeesManagementView.shortTerm.column.description')},
                {field: 'sm_qty', headerName: t('contractorMng.managerRFM.royalitiesFeesManagementView.shortTerm.column.sm_qty'), type: 'valueColumn'},
                {field: 'unitYear', headerName: t('contractorMng.managerRFM.royalitiesFeesManagementView.shortTerm.column.unitYear'), type: 'valueColumn'},
                {field: 'totalYear', headerName: t('contractorMng.managerRFM.royalitiesFeesManagementView.shortTerm.column.totalYear'), type: 'valueColumn' },
            ]
        },
        {headerName: "Importi Fatturati",
            children: [
                {field: 'january', headerName: t('contractorMng.managerRFM.royalitiesFeesManagementView.contractor.column.january'), valueFormatter: currencyFormatter, type: 'valueColumn' },
                {field: 'ninJanuary', headerName: t('contractorMng.managerRFM.royalitiesFeesManagementView.contractor.column.nrInvoices'), type: 'valueColumn' },
                {field: 'february', headerName: t('contractorMng.managerRFM.royalitiesFeesManagementView.contractor.column.february'), valueFormatter: currencyFormatter, type: 'valueColumn' },
                {field: 'ninFebruary', headerName: t('contractorMng.managerRFM.royalitiesFeesManagementView.contractor.column.nrInvoices'), type: 'valueColumn' },
                {field: 'march', headerName: t('contractorMng.managerRFM.royalitiesFeesManagementView.contractor.column.march'), valueFormatter: currencyFormatter, type: 'valueColumn' },
                {field: 'ninMarch', headerName: t('contractorMng.managerRFM.royalitiesFeesManagementView.contractor.column.nrInvoices'), type: 'valueColumn' },
                {field: 'april', headerName: t('contractorMng.managerRFM.royalitiesFeesManagementView.contractor.column.april'), valueFormatter: currencyFormatter, type: 'valueColumn' },
                {field: 'ninApril', headerName: t('contractorMng.managerRFM.royalitiesFeesManagementView.contractor.column.nrInvoices'), type: 'valueColumn' },
                {field: 'may', headerName: t('contractorMng.managerRFM.royalitiesFeesManagementView.contractor.column.may'), valueFormatter: currencyFormatter, type: 'valueColumn' },
                {field: 'ninMay', headerName: t('contractorMng.managerRFM.royalitiesFeesManagementView.contractor.column.nrInvoices'), type: 'valueColumn' },
                {field: 'june', headerName: t('contractorMng.managerRFM.royalitiesFeesManagementView.contractor.column.june'), valueFormatter: currencyFormatter, type: 'valueColumn' },
                {field: 'ninJune', headerName: t('contractorMng.managerRFM.royalitiesFeesManagementView.contractor.column.nrInvoices'), type: 'valueColumn' },
                {field: 'july', headerName: t('contractorMng.managerRFM.royalitiesFeesManagementView.contractor.column.july'), valueFormatter: currencyFormatter, type: 'valueColumn' },
                {field: 'ninJuly', headerName: t('contractorMng.managerRFM.royalitiesFeesManagementView.contractor.column.nrInvoices'), type: 'valueColumn' },
                {field: 'august', headerName: t('contractorMng.managerRFM.royalitiesFeesManagementView.contractor.column.august'), valueFormatter: currencyFormatter, type: 'valueColumn' },
                {field: 'ninAugust', headerName: t('contractorMng.managerRFM.royalitiesFeesManagementView.contractor.column.nrInvoices'), type: 'valueColumn' },
                {field: 'september', headerName: t('contractorMng.managerRFM.royalitiesFeesManagementView.contractor.column.september'), valueFormatter: currencyFormatter, type: 'valueColumn' },
                {field: 'ninSeptember', headerName: t('contractorMng.managerRFM.royalitiesFeesManagementView.contractor.column.nrInvoices'), type: 'valueColumn' },
                {field: 'october', headerName: t('contractorMng.managerRFM.royalitiesFeesManagementView.contractor.column.october'), valueFormatter: currencyFormatter, type: 'valueColumn' },
                {field: 'ninOctober', headerName: t('contractorMng.managerRFM.royalitiesFeesManagementView.contractor.column.nrInvoices'), type: 'valueColumn' },
                {field: 'november', headerName: t('contractorMng.managerRFM.royalitiesFeesManagementView.contractor.column.november'), valueFormatter: currencyFormatter, type: 'valueColumn' },
                {field: 'ninNovember', headerName: t('contractorMng.managerRFM.royalitiesFeesManagementView.contractor.column.nrInvoices'), type: 'valueColumn' },
                {field: 'december', headerName: t('contractorMng.managerRFM.royalitiesFeesManagementView.contractor.column.december'), valueFormatter: currencyFormatter, type: 'valueColumn' },
                {field: 'ninDecember', headerName: t('contractorMng.managerRFM.royalitiesFeesManagementView.contractor.column.nrInvoices'), type: 'valueColumn' },
                {field: 'total', headerName: t('contractorMng.managerRFM.royalitiesFeesManagementView.contractor.column.tot'), valueFormatter: currencyFormatter, type:'valueColumn'}
            ]
        }

    ], [i18n.language]);

    const columnShortTermDefs = useMemo<ColDef[]>(() => [
        {headerName: "",
            children: [
                {field: 'description', headerName: t('contractorMng.managerRFM.royalitiesFeesManagementView.shortTerm.column.description')},
                {field: 'note1', headerName: t('contractorMng.managerRFM.royalitiesFeesManagementView.shortTerm.column.note1'), type: 'noteColumn'},
                {field: 'note2', headerName: t('contractorMng.managerRFM.royalitiesFeesManagementView.shortTerm.column.note2'), type: 'noteColumn'},
                {field: 'totalYear', headerName: t('contractorMng.managerRFM.royalitiesFeesManagementView.shortTerm.column.totalYear'),type: 'valueColumn'},
            ]
        },
        {headerName:  t('contractorMng.managerRFM.royalitiesFeesManagementView.shortTerm.title'),
            children: [
                {field: 'january', headerName: t('contractorMng.managerRFM.royalitiesFeesManagementView.shortTerm.column.january'), valueFormatter: currencyFormatter, type: 'valueColumn'},
                {field: 'ninJanuary', headerName: t('contractorMng.managerRFM.royalitiesFeesManagementView.shortTerm.column.nrInvoices'), type: 'valueColumn' },
                {field: 'february', headerName: t('contractorMng.managerRFM.royalitiesFeesManagementView.shortTerm.column.february'), valueFormatter: currencyFormatter, type: 'valueColumn' },
                {field: 'ninFebruary', headerName: t('contractorMng.managerRFM.royalitiesFeesManagementView.shortTerm.column.nrInvoices'), type: 'valueColumn' },
                {field: 'march', headerName: t('contractorMng.managerRFM.royalitiesFeesManagementView.shortTerm.column.march'), valueFormatter: currencyFormatter, type: 'valueColumn' },
                {field: 'ninMarch', headerName: t('contractorMng.managerRFM.royalitiesFeesManagementView.shortTerm.column.nrInvoices'), type: 'valueColumn' },
                {field: 'april', headerName: t('contractorMng.managerRFM.royalitiesFeesManagementView.shortTerm.column.april'), valueFormatter: currencyFormatter, type: 'valueColumn' },
                {field: 'ninApril', headerName: t('contractorMng.managerRFM.royalitiesFeesManagementView.shortTerm.column.nrInvoices'), type: 'valueColumn' },
                {field: 'may', headerName: t('contractorMng.managerRFM.royalitiesFeesManagementView.shortTerm.column.may'), valueFormatter: currencyFormatter, type: 'valueColumn' },
                {field: 'ninMay', headerName: t('contractorMng.managerRFM.royalitiesFeesManagementView.shortTerm.column.nrInvoices'), type: 'valueColumn' },
                {field: 'june', headerName: t('contractorMng.managerRFM.royalitiesFeesManagementView.shortTerm.column.june'), valueFormatter: currencyFormatter, type: 'valueColumn' },
                {field: 'ninJune', headerName: t('contractorMng.managerRFM.royalitiesFeesManagementView.shortTerm.column.nrInvoices'), type: 'valueColumn' },
                {field: 'july', headerName: t('contractorMng.managerRFM.royalitiesFeesManagementView.shortTerm.column.july'), valueFormatter: currencyFormatter, type: 'valueColumn' },
                {field: 'ninJuly', headerName: t('contractorMng.managerRFM.royalitiesFeesManagementView.shortTerm.column.nrInvoices'), type: 'valueColumn' },
                {field: 'august', headerName: t('contractorMng.managerRFM.royalitiesFeesManagementView.shortTerm.column.august'), valueFormatter: currencyFormatter, type: 'valueColumn' },
                {field: 'ninAugust', headerName: t('contractorMng.managerRFM.royalitiesFeesManagementView.shortTerm.column.nrInvoices'), type: 'valueColumn' },
                {field: 'september', headerName: t('contractorMng.managerRFM.royalitiesFeesManagementView.shortTerm.column.september'), valueFormatter: currencyFormatter, type: 'valueColumn' },
                {field: 'ninSeptember', headerName: t('contractorMng.managerRFM.royalitiesFeesManagementView.shortTerm.column.nrInvoices'), type: 'valueColumn' },
                {field: 'october', headerName: t('contractorMng.managerRFM.royalitiesFeesManagementView.shortTerm.column.october'), valueFormatter: currencyFormatter, type: 'valueColumn' },
                {field: 'ninOctober', headerName: t('contractorMng.managerRFM.royalitiesFeesManagementView.shortTerm.column.nrInvoices'), type: 'valueColumn' },
                {field: 'november', headerName: t('contractorMng.managerRFM.royalitiesFeesManagementView.shortTerm.column.november'), valueFormatter: currencyFormatter, type: 'valueColumn' },
                {field: 'ninNovember', headerName: t('contractorMng.managerRFM.royalitiesFeesManagementView.shortTerm.column.nrInvoices'), type: 'valueColumn' },
                {field: 'december', headerName: t('contractorMng.managerRFM.royalitiesFeesManagementView.shortTerm.column.december'), valueFormatter: currencyFormatter, type: 'valueColumn' },
                {field: 'ninDecember', headerName: t('contractorMng.managerRFM.royalitiesFeesManagementView.shortTerm.column.nrInvoices'), type: 'valueColumn' },
                {field: 'total', headerName: t('contractorMng.managerRFM.royalitiesFeesManagementView.shortTerm.column.tot'), valueFormatter: currencyFormatter, type:'valueColumn'}
            ]
        }
    ], [i18n.language]);

    const columnCarSharingDefs = useMemo<ColDef[]>(() => [
        {headerName: "",
            children: [
                {field: 'description', headerName: t('contractorMng.managerRFM.royalitiesFeesManagementView.carSharing.column.description')},
                {field: 'note1', headerName: t('contractorMng.managerRFM.royalitiesFeesManagementView.carSharing.column.note1'), type: 'noteColumn'},
                {field: 'note2', headerName: t('contractorMng.managerRFM.royalitiesFeesManagementView.carSharing.column.note2'), type: 'noteColumn'},
                {field: 'totalYear', headerName: t('contractorMng.managerRFM.royalitiesFeesManagementView.carSharing.column.totalYear'),type: 'valueColumn'},
            ]
        },
        {headerName:  t('contractorMng.managerRFM.royalitiesFeesManagementView.carSharing.title'),
            children: [
                {field: 'january', headerName: t('contractorMng.managerRFM.royalitiesFeesManagementView.carSharing.column.january'), valueFormatter: currencyFormatter, type: 'valueColumn'},
                {field: 'ninJanuary', headerName: t('contractorMng.managerRFM.royalitiesFeesManagementView.carSharing.column.nrInvoices'), type: 'valueColumn' },
                {field: 'february', headerName: t('contractorMng.managerRFM.royalitiesFeesManagementView.carSharing.column.february'), valueFormatter: currencyFormatter, type: 'valueColumn' },
                {field: 'ninFebruary', headerName: t('contractorMng.managerRFM.royalitiesFeesManagementView.carSharing.column.nrInvoices'), type: 'valueColumn' },
                {field: 'march', headerName: t('contractorMng.managerRFM.royalitiesFeesManagementView.carSharing.column.march'), valueFormatter: currencyFormatter, type: 'valueColumn' },
                {field: 'ninMarch', headerName: t('contractorMng.managerRFM.royalitiesFeesManagementView.carSharing.column.nrInvoices'), type: 'valueColumn' },
                {field: 'april', headerName: t('contractorMng.managerRFM.royalitiesFeesManagementView.carSharing.column.april'), valueFormatter: currencyFormatter, type: 'valueColumn' },
                {field: 'ninApril', headerName: t('contractorMng.managerRFM.royalitiesFeesManagementView.carSharing.column.nrInvoices'), type: 'valueColumn' },
                {field: 'may', headerName: t('contractorMng.managerRFM.royalitiesFeesManagementView.carSharing.column.may'), valueFormatter: currencyFormatter, type: 'valueColumn' },
                {field: 'ninMay', headerName: t('contractorMng.managerRFM.royalitiesFeesManagementView.carSharing.column.nrInvoices'), type: 'valueColumn' },
                {field: 'june', headerName: t('contractorMng.managerRFM.royalitiesFeesManagementView.carSharing.column.june'), valueFormatter: currencyFormatter, type: 'valueColumn' },
                {field: 'ninJune', headerName: t('contractorMng.managerRFM.royalitiesFeesManagementView.carSharing.column.nrInvoices'), type: 'valueColumn' },
                {field: 'july', headerName: t('contractorMng.managerRFM.royalitiesFeesManagementView.carSharing.column.july'), valueFormatter: currencyFormatter, type: 'valueColumn' },
                {field: 'ninJuly', headerName: t('contractorMng.managerRFM.royalitiesFeesManagementView.carSharing.column.nrInvoices'), type: 'valueColumn' },
                {field: 'august', headerName: t('contractorMng.managerRFM.royalitiesFeesManagementView.carSharing.column.august'), valueFormatter: currencyFormatter, type: 'valueColumn' },
                {field: 'ninAugust', headerName: t('contractorMng.managerRFM.royalitiesFeesManagementView.carSharing.column.nrInvoices'), type: 'valueColumn' },
                {field: 'september', headerName: t('contractorMng.managerRFM.royalitiesFeesManagementView.carSharing.column.september'), valueFormatter: currencyFormatter, type: 'valueColumn' },
                {field: 'ninSeptember', headerName: t('contractorMng.managerRFM.royalitiesFeesManagementView.carSharing.column.nrInvoices'), type: 'valueColumn' },
                {field: 'october', headerName: t('contractorMng.managerRFM.royalitiesFeesManagementView.carSharing.column.october'), valueFormatter: currencyFormatter, type: 'valueColumn' },
                {field: 'ninOctober', headerName: t('contractorMng.managerRFM.royalitiesFeesManagementView.carSharing.column.nrInvoices'), type: 'valueColumn' },
                {field: 'november', headerName: t('contractorMng.managerRFM.royalitiesFeesManagementView.carSharing.column.november'), valueFormatter: currencyFormatter, type: 'valueColumn' },
                {field: 'ninNovember', headerName: t('contractorMng.managerRFM.royalitiesFeesManagementView.carSharing.column.nrInvoices'), type: 'valueColumn' },
                {field: 'december', headerName: t('contractorMng.managerRFM.royalitiesFeesManagementView.carSharing.column.december'), valueFormatter: currencyFormatter, type: 'valueColumn' },
                {field: 'ninDecember', headerName: t('contractorMng.managerRFM.royalitiesFeesManagementView.carSharing.column.nrInvoices'), type: 'valueColumn' },
                {field: 'total', headerName: t('contractorMng.managerRFM.royalitiesFeesManagementView.carSharing.column.tot'), valueFormatter: currencyFormatter, type:'valueColumn'}
            ]
        }
    ], [i18n.language]);

    const defaultColDef = useMemo(() => {
        return {
            lockPinned: true,
            suppressSizeToFit: true,
        }
    }, []);

    const columnTypes = useMemo<{[key: string]: ColDef;}>(() => ({
        valueColumn: {
            editable: isEditable,
            cellStyle: () => !isEditable ? {backgroundColor: 'lightBlue'} : undefined,
            valueParser: 'Number(newValue)',
            filter: 'agNumberColumnFilter',
        },
        noteColumn:{
            editable: isEditable,
            cellStyle: () => !isEditable ? {backgroundColor: 'lightBlue'} : undefined,
        }
    }), [isEditable]);

    const onBtExport = useCallback(() => {
        var spreadsheets = [];
        const sheet1 = gridRefContractor.current!.api.getSheetDataForExcel({
            sheetName: t('contractorMng.managerRFM.royalitiesFeesManagementView.excelExport.sheets.contractor'),
        });
        if (sheet1) {
            spreadsheets.push(sheet1);
        }
        const sheet2 = gridRefShortTime.current!.api.getSheetDataForExcel({
            sheetName: t('contractorMng.managerRFM.royalitiesFeesManagementView.excelExport.sheets.shortTerm'),
        });
        if (sheet2) {
            spreadsheets.push(sheet2);
        }
        const sheet3 = gridRefCarSharing.current!.api.getSheetDataForExcel({
            sheetName: t('contractorMng.managerRFM.royalitiesFeesManagementView.excelExport.sheets.carSharing'),
        });
        if (sheet3) {
            spreadsheets.push(sheet3);
        }
        gridRefContractor.current!.api.exportMultipleSheetsAsExcel({
            data: spreadsheets,
            fileName: `APTRSCAOther_${dayjs().format('YYYYMMDD')}.xlsx`,
        });
    }, []);

    const serverSideDatasourceContractor: IServerSideDatasource = useMemo(() => ({
        getRows(params) {
            const reqFullParams = {
                id: contractorDataState.id,
                paramRequest: {
                   pagination: 100,
                   startIndex: params.request.startRow,
                   endIndex: params.request.endRow
                }
            };

            getDashboardData(reqFullParams)
                .then((response: any) => {
                    const res = response.subConcessionContractData.length > 0 ? response.subConcessionContractData : DASHBOARD_CONTRACTOR_EMPTY_LIST
                    setContractorData(res);
                    params.success({ rowData: res, rowCount: res.length });
                })
                .catch(() => { params.fail() })
                .finally(() => { setIsSearching(false) })
        }
    }), [isSearching]);

    const serverSideDatasourceShortTerm: IServerSideDatasource = useMemo( () => ({
        getRows(params) {
            const reqFullParams = {
                id: contractorDataState.id,
                paramRequest: {
                    pagination: 100,
                    startIndex: params.request.startRow,
                    endIndex: params.request.endRow
                }};

            getDashboardData(reqFullParams)
                .then((response: any) => {
                    const res = response.shortTerm.length > 0 ? response.shortTerm : DASHBOARD_SHORT_TERMS_EMPTY_LIST;
                    setShortTermsData(res)
                    params.success({ rowData: res, rowCount: res.length })
                })
                .catch(() => { params.fail() })
                .finally(() => { setIsSearching(false); })
        }
    }), [isSearching]);

    const serverSideDatasourceCarSharing: IServerSideDatasource = useMemo( () => ({
        getRows(params) {
            const reqFullParams = {
                id: contractorDataState.id,
                paramRequest: {
                    pagination:  100,
                    startIndex:  params.request.startRow,
                    endIndex:  params.request.endRow
                }};

            getDashboardData(reqFullParams)
                .then((response: any) => {
                    const res = response.carSharing.length > 0 ? response.carSharing : DASHBOARD_CAR_SHARING_EMPTY_LIST;
                    setCarSharingData(res)
                    params.success({ rowData: res, rowCount: res.length })
                    setIsSearching(false);
                })
                .catch(() => {
                    params.fail();
                    setIsSearching(false);
                }).finally(() => { setIsSearching(false) })
        }
    }), [isSearching]);

    const setEditableTable = useCallback((b: boolean) => {
        setIsEditable(b);
        gridRefContractor.current!.api.redrawRows();
        gridRefShortTime.current!.api.redrawRows();
        gridRefCarSharing.current!.api.redrawRows();
    }, [isEditable]);


    function blobToFile(theBlob: any, fileName: string){
        theBlob.lastModifiedDate = new Date();
        theBlob.name = fileName;
        return theBlob;
    }

    const createNewDashboard = useCallback(() => {
        handleClose();
        const spreadsheets = [];
        const reqParams: any = {};
        const dataFromTables = gridRefCarSharing.current!.api.getSheetDataForExcel({
            sheetName: t('contractorMng.managerRFM.royalitiesFeesManagementView.sheets.carSharing'),
        });
        const dataFromTables2 = gridRefShortTime.current!.api.getSheetDataForExcel({
            sheetName: t('contractorMng.managerRFM.royalitiesFeesManagementView.sheets.shortTerm'),
        });
        const dataFromTables3 = gridRefContractor.current!.api.getSheetDataForExcel({
            sheetName: t('contractorMng.managerRFM.royalitiesFeesManagementView.sheets.contractor'),
        });
        if(dataFromTables && dataFromTables2 && dataFromTables3){
            spreadsheets.push(dataFromTables,dataFromTables2,dataFromTables3);
        }
        const myfile = gridRefContractor.current!.api.getMultipleSheetsAsExcel({data: spreadsheets, fileName: 'ag-grid.xlsx'});
        const file = blobToFile(myfile, "");
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            reqParams.file= reader.result;
            reqParams.fileName= `APTRSCAOther_${dayjs().format('YYYYMMDD')}.xlsx`;
            reqParams.id = contractorDataState.id;
            saveDashboardFile(reqParams)
                .then(() => {
                    const reqEmptyLists = {
                        id: contractorDataState.id,
                        subConcessionContractData: DASHBOARD_CONTRACTOR_EMPTY_LIST,
                        shortTerm: DASHBOARD_SHORT_TERMS_EMPTY_LIST,
                        carSharing: DASHBOARD_CAR_SHARING_EMPTY_LIST
                    }
                    updateDashboard(reqEmptyLists)
                        .then(() => {
                            setContractorData(DASHBOARD_CONTRACTOR_EMPTY_LIST);
                            setShortTermsData(DASHBOARD_SHORT_TERMS_EMPTY_LIST);
                            setCarSharingData(DASHBOARD_CAR_SHARING_EMPTY_LIST);
                            gridRefContractor.current!.api.refreshServerSide({ route: undefined, purge: true });
                            gridRefShortTime.current!.api.refreshServerSide({ route: undefined, purge: true });
                            gridRefCarSharing.current!.api.refreshServerSide({ route: undefined, purge: true });
                            setReload(!reload);
                        }).catch(console.error)
                }).catch(console.error);
        };
    }, []);

    const onContractorCellValueChanged = useCallback((params: CellValueChangedEvent) => {
        let changedData = [params.data];
        setContractorData(contractorData.map((x) => changedData[0].description === x.description ? changedData[0] : x));
        gridRefContractor.current!.api.applyTransaction({ update: contractorData.map((x) => changedData[0].description === x.description ? changedData[0] : x) });
    }, [contractorData]);

    const onShortTermCellValueChanged = useCallback( (params: CellValueChangedEvent) => {
        let changedData = [params.data];
        setShortTermsData(shortTermsData.map((x) => changedData[0].description === x.description ? changedData[0] : x));
        gridRefShortTime.current!.api.applyTransaction({ update: shortTermsData.map((x) => changedData[0].description === x.description ? changedData[0] : x) });
    }, [shortTermsData]);

    const onCarSharingCellValueChanged = useCallback((params: CellValueChangedEvent) => {
        let changedData = [params.data];
        setCarSharingData(carSharingData.map((x) => changedData[0].description === x.description ? changedData[0] : x));
        gridRefCarSharing.current!.api.applyTransaction({ update: carSharingData.map((x) => changedData[0].description === x.description ? changedData[0] : x) });
    },[carSharingData]);

    const saveDashboard = () => {
        gridRefContractor.current?.api.clearFocusedCell();
        gridRefShortTime.current?.api.clearFocusedCell();
        gridRefCarSharing.current?.api.clearFocusedCell();

        setEditableTable(false)
        const reqParams = {
            id: contractorDataState.id,
            subConcessionContractData: contractorData,
            shortTerm: shortTermsData,
            carSharing: carSharingData
        };

        updateDashboard(reqParams).then( () => setIsEditable(false)).catch(console.error);
    }

    return (
        <>
            <Grid item xs={12} sx={{my: theme.spacing(2)}}>
                <Stack direction="row" spacing={2} justifyContent="flex-end" alignItems="flex-end">
                    {!isEditable ? (
                        <Tooltip title={t("contractorMng.managerRFM.royalitiesFeesManagementView.tooltip.edit")}>
                            <IconButton color="accent">
                                <EditRounded onClick={() => {setEditableTable(true)}} />
                            </IconButton>
                        </Tooltip>
                    ) : (
                        <Button onClick={saveDashboard}>
                            {t('contractorMng.managerRFM.royalitiesFeesManagementView.buttons.confirm')}
                        </Button>
                    )}

                    <Button  onClick={onBtExport} color="accent" variant="contained" component="label" endIcon={<DownloadRounded/>}>
                        {t('contractorMng.managerRFM.royalitiesFeesManagementView.buttons.exportExcel')}
                    </Button>

                    <Button onClick={() => handleOpen()}>
                        {t('contractorMng.managerRFM.royalitiesFeesManagementView.buttons.generateNewDashboard')}
                    </Button>

                    <Button onClick={() => handleOpenHistory()}>
                        {t('contractorMng.managerRFM.royalitiesFeesManagementView.buttons.dashboardArchive')}
                    </Button>
                </Stack>
            </Grid>


            <Accordion defaultExpanded>
                <AccordionSummary expandIcon={<ExpandMore />}>
                    <Typography variant="h6">
                        {t('contractorMng.managerRFM.royalitiesFeesManagementView.accordion.subconcession')}
                    </Typography>
                </AccordionSummary>

                <AccordionDetails>
                    <AgGridCustomTable
                        gridRef={gridRefContractor}
                        columnDefs={columnContractorDefs}
                        columnTypes={columnTypes}
                        rowModelType='serverSide'
                        serverSideInfiniteScroll
                        serverSideDatasource={serverSideDatasourceContractor}
                        onCellValueChanged={onContractorCellValueChanged}
                        gridOptions={
                            {
                                defaultColDef,
                                onGridReady: (event) => {
                                    event.api.sizeColumnsToFit()
                                }
                            }
                        }
                    />
                </AccordionDetails>
            </Accordion>

            <Accordion defaultExpanded>
                <AccordionSummary expandIcon={<ExpandMore />}>
                    <Typography variant="h6">
                        {t('contractorMng.managerRFM.royalitiesFeesManagementView.accordion.shortTerm')}
                    </Typography>
                </AccordionSummary>

                <AccordionDetails>
                    <AgGridCustomTable
                        gridRef={gridRefShortTime}
                        columnDefs={columnShortTermDefs}
                        columnTypes={columnTypes}
                        rowModelType='serverSide'
                        serverSideInfiniteScroll
                        serverSideDatasource={serverSideDatasourceShortTerm}
                        onCellValueChanged={onShortTermCellValueChanged}
                        gridOptions={
                            {
                                defaultColDef,
                                onGridReady: (event) => {
                                    event.api.sizeColumnsToFit()
                                }
                            }
                        }
                    />
                </AccordionDetails>
            </Accordion>

            <Accordion defaultExpanded>
                <AccordionSummary expandIcon={<ExpandMore />}>
                    <Typography variant="h6">
                        {t('contractorMng.managerRFM.royalitiesFeesManagementView.accordion.carSharing')}
                    </Typography>
                </AccordionSummary>

                <AccordionDetails>
                    <AgGridCustomTable
                        gridRef={gridRefCarSharing}
                        columnDefs={columnCarSharingDefs}
                        columnTypes={columnTypes}
                        rowModelType='serverSide'
                        serverSideInfiniteScroll
                        serverSideDatasource={serverSideDatasourceCarSharing}
                        onCellValueChanged={onCarSharingCellValueChanged}
                        gridOptions={
                            {
                                defaultColDef,
                                onGridReady: (event) => {
                                    event.api.sizeColumnsToFit()
                                }
                            }
                        }
                    />
                </AccordionDetails>
            </Accordion>

            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {t('contractorMng.managerRFM.royalitiesFeesManagementView.dialogs.newDashboard.title')}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {t('contractorMng.managerRFM.royalitiesFeesManagementView.dialogs.newDashboard.description')}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={createNewDashboard} autoFocus>
                        {t('contractorMng.managerRFM.royalitiesFeesManagementView.dialogs.newDashboard.buttons.confirm')}
                    </Button>
                    <Button onClick={handleClose}>
                        {t('contractorMng.managerRFM.royalitiesFeesManagementView.dialogs.newDashboard.buttons.cancel')}
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={openHistory}
                onClose={handleCloseHistory}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth="lg"
                fullWidth
            >
                <DialogTitle id="alert-dialog-title">
                    {t('contractorMng.managerRFM.royalitiesFeesManagementView.dialogs.newDashboard.title')}
                </DialogTitle>
                <DialogContent>
                    <DashboardHistory functionality="CONTR_EXC" id={contractorDataState.id}/>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseHistory}>
                        {t('contractorMng.managerRFM.royalitiesFeesManagementView.dialogs.newDashboard.buttons.cancel')}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}

export default CurrentYearDashboardView
